import { render, staticRenderFns } from "./package-details.vue?vue&type=template&id=1400b550&"
import script from "./package-details.vue?vue&type=script&lang=js&"
export * from "./package-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports